/* eslint-disable consistent-return */
import { baseUrl } from "util/APIBaseUrl";
import getRequest from "util/APIHelperGet";
import postRequest from "util/APIHelperPost";

export const getEmployeeTimeOffDetails = async (payload) => {
  try {
    const { employeeId, startDate, endDate, leaveTypeId, anniversaryBasedTimeOff } = payload;
    const response = await getRequest(
      `${baseUrl}${anniversaryBasedTimeOff ? "/v2" : ""}/admin/leaveRequests?` +
        `employeeId=${employeeId || ""}&` +
        `startDate=${startDate || ""}&` +
        `endDate=${endDate || ""}&` +
        `leaveTypeId=${leaveTypeId || ""}`,
      true
    );
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};

export const getEmployeeLeavesDataForAdmin = async (employeeId, anniversaryBasedTimeOff) => {
  try {
    const response = await getRequest(
      `${baseUrl}${anniversaryBasedTimeOff ? "/v2" : ""}/admin/leave_types/${employeeId}`,
      true
    );
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};

export const addEmployeeNewLeaveRequest = async (body) => {
  try {
    const response = await postRequest(`${baseUrl}/v3/employee/leave`, JSON.stringify(body));
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};

// PRD-442: V4 admin leave creation with future cycle support
export const addEmployeeNewLeaveRequestV4 = async (body) => {
  try {
    const response = await postRequest(`${baseUrl}/v4/admin/createLeave`, JSON.stringify(body));
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};

export const getEmployeeLeavesDataForAdminV4 = async (employeeId) => {
  try {
    const response = await getRequest(`${baseUrl}/v4/employee/${employeeId}/leave_types`, true);
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};

export const getTotalLeaveCount = async (employeeId, leaveId, startDate, endDate, excludeRequestId = null) => {
  try {
    let url = `${baseUrl}/admin/${employeeId}/count_leaves/${leaveId}?dateFrom=${startDate}&dateTo=${endDate}`;
    if (excludeRequestId) {
      url += `&excludeRequestId=${excludeRequestId}`;
    }
    const response = await getRequest(url);
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};

export const getTotalLeaveCountV2 = async (employeeId, leaveId, startDate, endDate, excludeRequestId = null) => {
  try {
    let url = `${baseUrl}/v2/admin/${employeeId}/count_leaves/${leaveId}?dateFrom=${startDate}&dateTo=${endDate}`;
    if (excludeRequestId) {
      url += `&excludeRequestId=${excludeRequestId}`;
    }
    const response = await getRequest(url);
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};

export const getEmployeeDocuments = async (request) => {
  try {
    const response = await getRequest(`${baseUrl}/${request}`, true);
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};

export const addSwappedLeaves = async (body) => {
  try {
    const response = await postRequest(`${baseUrl}/admin/swapped_leaves`, JSON.stringify(body));
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};

export const getEmployeesLeaveAndHolidays = async (employeeId, startDate, endDate) => {
  try {
    const response = await getRequest(
      `${baseUrl}/admin/employee/${employeeId}/leave_holidays?startDate=${startDate}&endDate=${endDate}`,
      true
    );
    return response.payload;
  } catch (error) {
    console.log(error);
  }
};
